// These feature-flags are common across AC and PPC

//Flag to enable Error Reporting component
export const ENABLE_REPORT_ERROR = 'app.enable-feedback-and-error-reporting';
